import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';

import AccordionToggle from '../../components/AccordionToggle';
import CommunityHomeCard from './CommunityHomeCard';
import { UnderdogCenter } from '../../helpers/UIElements';

const styles = css`
  @media(min-width: 992px) {
    padding-bottom: 130px;
  }
  .CommunityHomes_cardsList {
    width: 100%;
    padding: 0 0 15px 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    background-color: white;
    z-index: 1;
    position: relative;
  }
  .CommunityHomes_title {
    display: none;
    @media(min-width: 992px) {
    border-bottom: 0;
    text-transform: uppercase;
    background-color: transparent;
    background-image: none;
    font-weight: 700;
    font-size: 21px;
    color: #212121;
    letter-spacing: 5px;
    text-align: center;
    line-height: 32px;
    position: relative;
    display: inherit;
    flex-direction: column;
    padding: 0 20px;
    }
  }
  .CommunityHomes_button {
    @media(min-width: 992px) {
      padding: 45px 0;
    }
  }
`;

const Increment = 8;

class CommunityHomes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: Increment,
    };
  }
  loadMoreHomes = () => {
    this.setState({ limit: this.state.limit + Increment });
  }
  render() {
    const { limit } = this.state;
    const { homes } = this.props;
    return (
      <div className={styles}>
        <div id="homes" className="CommunityHomes_scrollTarget" />
        <AccordionToggle
          openOnId="homes"
          button={({ contentVisible }) => (
            <div className="DetailsSection_btn d-lg-none" role="button" tabIndex={0}>
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Community Homes</h3>
            </div>
          )}
        >
          <div className="container mb-lg-10">
            <UnderdogCenter className="d-none d-lg-block">
              <h3 className="CommunityHomes_title">Community Homes</h3>
            </UnderdogCenter>
            <div className="CommunityHomes_cardsList">
              {
                homes.slice(0, limit).map(home => (
                  <CommunityHomeCard home={home} key={home._id} />
                ))
              }
            </div>
            {
              homes.length > limit &&
              <div className="CommunityHomes_button">
                <div className="d-flex justify-content-center"><span onClick={this.loadMoreHomes} role="button" tabIndex={0} className="Btn_default">Load More Homes</span></div>
              </div>
            }
          </div>
        </AccordionToggle>
      </div>
    );
  }
}

CommunityHomes.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CommunityHomes;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityHomes.js